import { FC, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import './static/ProductsCard.scss'
import { ModalProduct } from './ModalProduct'
import { CardProduct } from './CardProduct'

export type Product = {
	title: string
	desc: string
	photo: string

	isModal?: boolean
	isDocument?: boolean

	modalPhotos?: string[]
	modalDescription?: string
	modalPhotosHeight?: string

	document?: string
}

interface ProductsCardProps {
	index: number
	title: string
	products: Product[]
}

const ProductsCard: FC<ProductsCardProps> = ({ index, title, products }) => {
	const [ref, inView] = useInView({ triggerOnce: true })
	return (
		<div
			ref={ref}
			className={`products-card ${inView ? 'animate' : ''}`}
			style={
				inView
					? { animation: `card-animation ${0.5 + index / 4}s ease-in-out` }
					: {}
			}
		>
			<div className='category-title'>
				<span>{title}</span>
			</div>

			<div className='products-list'>
				{products.map((product, i) => (
					<CardProduct key={i} {...product}/>
				))}
			</div>

		</div>
	)
}

export default ProductsCard
